import React, { createContext, useContext } from "react";
import type { Config, RootState } from "../../customers2/types";
import { useSelector } from "react-redux";

import {
  CABINET_TYPE_ADVERT,
  CABINET_TYPE_EXCHANGE,
  CABINET_TYPE_WEBMASTER,
  CABINET_TYPE_DSP
} from "../constants/config";

interface IPropsConfigProvider {
  children: any;
}

class ConfigManager {
  config: Config;

  constructor(props: Config) {
    this.config = props;
  }

  isAdwile() {
    return this.config.CABINET_TYPE === CABINET_TYPE_ADVERT;
  }
  isExchange() {
    return this.config.CABINET_TYPE === CABINET_TYPE_EXCHANGE;
  }
  isWebmaster() {
    return this.config.CABINET_TYPE === CABINET_TYPE_WEBMASTER;
  }
  isDSP() {
    return this.config.CABINET_TYPE === CABINET_TYPE_DSP;
  }
  teaserImgUrl(image: string, size = "") {
    return `${this.config.TEASER_IMAGE_HOST}${size}/${image}`;
  }
  getCabinetTitle() {
    if (this.isAdwile()) return "Рекламодатель";
    if (this.isWebmaster()) return "Монетизация";
    if (this.isExchange()) return "Обмен трафиком";
    if (this.isDSP()) return "DSP";
  }
}

const ConfigContext = createContext(null);

export const useConfig = () => useContext(ConfigContext);

export default function ConfigProvider(props: IPropsConfigProvider) {
  const { children } = props;

  const config: Config = useSelector((state: RootState) => state.config);

  return (
    <ConfigContext.Provider value={new ConfigManager(config)}>
      {children}
    </ConfigContext.Provider>
  );
}
